export default __webpack_public_path__ + "static/media/DNo.24-0.0bb1f61c.jpg";